module.exports = {
  CONSENT_MANAGEMENT_TOGGLE: 'consent-management-enabled',
  CONSENT_MANAGEMENT_CONFIG: 'consent-management-config',
  USER_CONSENT_NOT_FOUND_CODE: 10201,
};
